import { takeLatest, call, put } from "redux-saga/effects";
import { request, showNotification } from "@thewebops/admin-panel";
import actions from "./actions";

function* exportNutibite(action) {
  const { item } = action.payload;
  const { success, failure } = actions.exportNutibite;
  try {
    yield call(request, {
      url: `admin/export_documents`,
      method: "post",
      authenticated: true,
      data: {
        exportable_id: item.id,
        exportable_type: 'Lesson',
      }
    });
    showNotification('Exercise', "success");
    yield put(success(item));
  } catch (error) {
    yield put(failure());
  }
}


function* watchEntityexportNutibite() {
  const { request } = actions.exportNutibite;
  yield takeLatest(request, exportNutibite);
}


export default [watchEntityexportNutibite];
